<div class="d-flex justify-content-end mb-2 mr-4">
  <button class="btn btn-info" routerLink="{{addItemLink}}">
    <fa-icon [icon]="faPlusCircle"></fa-icon>
  </button>
</div>
